"use client";
import constate from "constate";
import { useState } from "react";
import { getPurchaseOrder } from "@/app/(hub)/purchase-orders/services";
import {
  PurchaseOrder,
  PurchaseOrderItem,
  NewPurchaseOrderItem,
  PurchaseOrderStatus,
} from "@/app/(hub)/purchase-orders/types";

function usePurchaseOrderStore() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | undefined>();
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] =
    useState<PurchaseOrder>();
  const [type, setType] = useState(PurchaseOrderStatus.DRAFT);
  const [items, setItems] = useState<NewPurchaseOrderItem[]>([]);
  const newItem = {
    name: "",
    quantity: 1,
    productId: "",
    product: {
      id: "",
      name: "",
    },
    variant: {
      id: "",
      name: "",
      price: 0,
      unit: "",
      sku: "",
    },
  };

  async function fetchPurchaseOrder(id: string) {
    const purchaseOrder: PurchaseOrder = await getPurchaseOrder(id);
    const editItems = purchaseOrder.items.map((item: PurchaseOrderItem) => {
      return {
        ...item,
        product: {
          id: item.product.id,
          name: item.product.name,
        },
        variant: {
          id: item.variant?.id,
          name: item.variant?.name,
          price: item.variant?.price / 100,
          unit: item.variant.unit,
          sku: item.variant.sku,
        },
        productId: item.product.id,
        quantity: item.quantity,
        name: item.product.name,
      };
    });
    setSelectedPurchaseOrder({ ...purchaseOrder, items: editItems });
    setItems([...editItems]);
  }

  return {
    open,
    setOpen,
    selected,
    setSelected,
    selectedPurchaseOrder,
    fetchPurchaseOrder,
    newItem,
    items,
    setItems,
    type,
    setType,
  };
}

export const [PurchaseOrderProvider, usePurchaseOrderContext] = constate(
  usePurchaseOrderStore,
);
